import {SET_HISTORY, ADD_USERCHALLENGES} from 'actions/types';

var challengesInitialState = {
        historyList:[], 
        isHistoryListLoaded:false, 
        indexed:{},
        companyAnnouncementIdToId:{},
    };
export default (state = challengesInitialState, action) => {
    switch(action.type) {
        case SET_HISTORY: 
            return {...state,
                    historyList:action.userChallenges.map((uc)=>(uc.id)),
                    indexed:action.userChallenges.reduce((m,uc)=>{m[uc.id]=uc;return m;},{...state.indexed}),
                    companyAnnouncementIdToId:action.userChallenges.filter(uc=>uc.companyAnnouncementId!=null).reduce((m,uc)=>{m[uc.companyAnnouncementId]=uc.id;return m;},{...state.companyAnnouncementIdToId}),
                    isHistoryListLoaded:true
                    };
        case ADD_USERCHALLENGES: 
            return {...state,
                    indexed:action.userChallenges.reduce((m,uc)=>{m[uc.id]=uc;return m;},{...state.indexed}),
                    companyAnnouncementIdToId:action.userChallenges.filter(uc=>uc.companyAnnouncementId!=null).reduce((m,uc)=>{m[uc.companyAnnouncementId]=uc.id;return m;},{...state.companyAnnouncementIdToId}),
                    };
        default:            
            return state;
    }
}

//selectors
export const isHistoryListLoaded  = state => state.isHistoryListLoaded;
export const getHistory = state => state.historyList.map( id => state.indexed[id] );
export const getUserChallenge = (state, id) => state.indexed[id];
export const getUserChallengeByCompanyAnnouncementId = (state, companyAnnouncementId) => state.indexed[state.companyAnnouncementIdToId[companyAnnouncementId]];



// WEBPACK FOOTER //
// ./src/reducers/userChallenges.js